import React from "react";

import Image1 from "../../assets/img/gallery1.png";
import Image2 from "../../assets/img/gallery2.png";
import Image3 from "../../assets/img/gallery3.png";
import Image4 from "../../assets/img/gallery4.png";

const Gallery = () => {
  return (
    <section className="gallery-section py-12 bg-gray-100 text-center justify-center">
      <div id="projects" className="container mx-auto text-center justify-center">
        {/* Title */}
        <h2 className="text-center text-2xl lg:text-4xl font-bold text-gray-800 mb-8">
          Our Gallery
        </h2>
        <div className="grid grid-cols-2 gap-6">
          <img
            src={Image1}
            alt="Gallery Image 1"
            className="rounded-lg shadow-lg"
          />
          <img
            src={Image2}
            alt="Gallery Image 2"
            className="rounded-lg shadow-lg"
          />
          <img
            src={Image3}
            alt="Gallery Image 3"
            className="rounded-lg shadow-lg"
          />
          <img
            src={Image4}
            alt="Gallery Image 4"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default Gallery;